import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/hooks/use-theme';

interface ThemeToggleButtonProps {
  className?: string;
}

/** Site-wide theme toggle for the public navbar (light/dark). */
export default function ThemeToggleButton({ className = '' }: ThemeToggleButtonProps) {
  const { isDark, toggleTheme } = useTheme();
  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={isDark ? 'Hellen Modus aktivieren' : 'Dunklen Modus aktivieren'}
      title={isDark ? 'Heller Modus' : 'Dunkler Modus'}
      className={`inline-flex h-11 w-11 items-center justify-center rounded-full hover:bg-accent/60 hover:text-primary transition-colors text-muted-foreground ${className}`}
    >
      {isDark ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
    </button>
  );
}
